<template>
	<!-- 사용 예시 : qms/FreeForm/Content/Table/TableSolutionTwo.vue -->
	<div class="qms-file-upload position-relative w-100">
		<div class="w-80 mr-5 h-100">
			<input type="file" :id="id" @change="onChange" multiple />
			<div class="w-100 qms-file-upload__frame addScroll">
				<template v-for="(file, index) in fileNames">
					<template v-if="fileList[index].fileSeq">
						<div class="qms-file-upload__item py-1" style="text-align: left" :key="index">
							<span class="file-upload__item__name" @click="() => onDownload(index)">{{ file }}</span>
							<i class="icon-sf-circle-close" @click="() => deleteFile(index)" v-show="isEditable" />
						</div>
					</template>
					<template v-else>
						<div class="qms-file-upload__temp py-1" style="text-align: left" :key="index">
							<span class="file-upload__temp__name">{{ file }}</span>
							<i class="icon-sf-circle-close" @click="() => deleteFile(index)" v-show="isEditable" />
						</div>
					</template>
				</template>
			</div>
		</div>
		<template v-if="isEditable">
			<label :for="id" class="unit input-icon"><img class="m-auto" src="/img/common/table/icon-sf-excel.svg" alt="excel icon" /></label>
			<label class="unit input-icon" style="margin-top: 40px !important" @click="deleteAction">
				<i class="icon-sf-trash" />
			</label>
			<!-- <label for="upload" class="unit input-icon" style="margin-top: 40px !important"><i class="icon-sf-download" /></label> -->
		</template>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	name: 'file-upload-table',
	props: {
		id: { type: String, default: '' + (Math.random() * 10000 + 1) },
		propFileList: {
			type: Array,
			default() {
				return [];
			}
		},
		isEditable: { type: Boolean, default: true }
	},
	data() {
		return {
			fileList: [],
			delFileList: [] // db 저장건 삭제할 목록
		};
	},
	created() {
		this.fileList = [...this.propFileList];
	},
	computed: {
		...rootComputed,
		fileNames() {
			return this.fileList?.map(file => {
				let flNm = file.origFileName || file.fileName || file.name || '';
				const name = flNm.substring(0, Math.min(flNm.lastIndexOf('.'), 60));
				const ext = flNm.substring(flNm.lastIndexOf('.') + 1);
				return name + '.' + ext;
			});
		}
	},
	watch: {
		fileList() {
			this.$emit('MultiFile', this.fileList, this.delFileList);
		}
	},
	methods: {
		...rootMethods,
		onChange({ target: { files } }) {
			//console.log('files ::', files);
			for (const file of files) {
				this.fileList.push(file);
			}
		},
		deleteFile(index) {
			const isNotTemp = !!this.fileList[index].fileSeq;
			if (isNotTemp) {
				this.delFileList.push(this.fileList[index]);
			}
			this.fileList.splice(index, 1);
		},
		deleteAction() {
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
				buttons: [{ title: this.getMessage_('MWCC000107'), clickFn: this.deleteAllFiles }] //삭제
			});
		},
		deleteAllFiles() {
			this.delFileList = this.fileList.filter(file => !!file.fileSeq);
			this.fileList = [];
		},
		async onDownload(index) {
			if (this.fileList[index].fileSeq) {
				this.$emit('onDownload', this.fileList[index]);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.qms-file-upload {
	&__frame {
		border: 1px solid #8da1b9;
		border-radius: 5px;
		min-height: 200px;
	}
	&__temp {
		&:hover {
			background-color: var(--color-table-line);
		}
		.icon-sf-circle-close {
			color: #335174;
		}
	}
}
</style>
